<template lang="html">
    <div class="mb-4">
        <label v-if="label" for="" v-html="label" :style="styleLabel"></label>
        <div class="vs-con-input">
            <span v-html="value"></span>
        </div>
    </div>
</template>

<script>
import _color from '@/assets/utils/color.js'
export default {
    name: 'vx-output',
    inheritAttrs: false,
    props: {
        value: {
            default: '',
            type: [String, Number]
        },
        label: {
            default: null,
            type: [String, Number]
        },
        color: {
            default: 'primary',
            type: String
        },
        size: {
            default: 'normal',
            type: String
        }
    },
    data: () => ({
        isFocus: false
    }),
    computed: {
        style() {
            return {
                border: `1px solid ${_color.getColor(this.color, 1)}`
            }
        },
        styleLabel() {
            return { color: `rgba(var(--vs-${this.color}), 1)` }
        }
    },
    methods: {}
}
</script>
